/*
 * @Author: Teemo Ding
 * @Date: 2021-11-17 13:49:02
 * @LastEditTime: 2022-06-27 16:19:54
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/order/refund.ts
 */
import {
  get, // post
  post,
} from 'src/tools/server';
import { EOperationType } from '@/src/types/common/order';

const getRequestPage = (orderUuid?: string, type?: EOperationType) => {
  return get<any>(`/portal/order/return/request/${orderUuid}/${type}`, {});
};
const confirmRefundRequest = (data) => {
  return post<any>(`/portal/order/return/confirmRefundRequest`, data, {});
};
const confirmReturnRequest = (data) => {
  return post<any>(`/portal/order/return/confirmReturnRequest`, data, {});
};

const approveReturnRequest = (returnUuid) => {
  return get<any>(`/portal/order/return/approve/${returnUuid}`, {});
};
const rejectReturnRequest = (data) => {
  return post<any>(`/portal/order/return/reject`, data, {});
};
const approveRefundRequest = (returnUuid) => {
  return get<any>(`/portal/order/refund/approve/${returnUuid}`, {});
};
const rejectRefundRequest = (data) => {
  return post<any>(`/portal/order/refund/reject`, data, {});
};
const viewDetail = (returnUuid) => {
  return get<any>(`/portal/order/return/detail/${returnUuid}`, {});
};
const confirmLogistics = (data) => {
  return post<any>(`/portal/order/return/confirmLogistics`, data, {});
};
const onlineRefund = (orderRefundTransactionUuid) => {
  return get<any>(
    `/portal/order/return/refund/online/${orderRefundTransactionUuid}`,
    {},
  );
};
const onlineRefundNotify = (data) => {
  return post<any>(`/portal/order/return/refund/online`, data, {});
};

const manualRefund = (data) => {
  return post<any>(`/portal/order/return/refund/manual`, data, {});
};
const returnToRefundConfirmPage = (returnUuid) => {
  return get<any>(
    `/portal/order/return/returnToRefundConfirmPage/${returnUuid}`,
    {},
  );
};
const markReturned = (returnUuid) => {
  return get<any>(`/portal/order/return/markReturned/${returnUuid}`, {});
};

const cancelReturnComplete = (data) => {
  return post<any>(`/portal/order/return/complete`, data, {});
};

export {
  getRequestPage,
  markReturned,
  confirmRefundRequest,
  confirmReturnRequest,
  approveRefundRequest,
  approveReturnRequest,
  rejectReturnRequest,
  rejectRefundRequest,
  viewDetail,
  confirmLogistics,
  returnToRefundConfirmPage,
  onlineRefund,
  cancelReturnComplete,
  manualRefund,
  onlineRefundNotify,
};
